import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "19",
      height: "19",
      x: ".5",
      y: ".5",
      stroke: "#1F2125",
      rx: "9.5"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#1F2125",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M7.985 14.531a4.958 4.958 0 0 0 6.309-7.01l-.146-.253M5.705 12.48a4.958 4.958 0 0 1 6.309-7.01m-7.56 7.059 1.594.427.427-1.594m7.05-2.723.426-1.593 1.594.427"
    }, null, -1)
  ]))]))
}
export default { render: render }